import {connect} from '@modifi/redux'

import RouteEntrypoint, {RouteEntrypointProps} from './RouteEntrypoint'
import {selectNavigationTarget, selectNavigationTargetIsLoading} from '../../store'

const mapStateToProps = (
  state: Record<string, any>,
  ownProps: {sectionName: string}
): Pick<RouteEntrypointProps, 'target' | 'isLoading'> => ({
  target: selectNavigationTarget(state, ownProps.sectionName),
  isLoading: selectNavigationTargetIsLoading(state, ownProps.sectionName),
})

const mapDispatchToProps = {}

export default connect(mapStateToProps, mapDispatchToProps)(RouteEntrypoint)
